<template>

    <form @submit.prevent="submit" @keydown="value.onKeydown($event)">
        <notifications position="right top"/>

        <!-- Location -->
        <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('gym_location') }}</label>
            <div class="col-md-7">
                <ss-location v-model="value.location"
                             :city-id="value.city_id"
                             :errors="errors"></ss-location>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('title') }}</label>
            <div class="col-md-7">
                <input v-model="value.title"
                       type="text"
                       name="title"
                       class="form-control"
                       required
                       minlength="5"
                       :class="{ 'is-invalid': errors.has('title') }"
                       :title="$t('title')">
                <has-error :form="value" field="title"></has-error>
            </div>
        </div>

        <!--<div class="form-group row">-->
            <!--<label class="col-md-3 col-form-label text-md-right">{{ $t('url_ident') }}</label>-->
            <!--<div class="col-md-7">-->
                <!--<ssHostname v-model="value.web_hostname"-->
                            <!--:errors="errors"-->
                            <!--@change-type="changeTypeUrl"></ssHostname>-->
            <!--</div>-->
        <!--</div>-->

        <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('address') }}</label>
            <div class="col-md-7">
                <input v-model="value.address"
                       type="text"
                       name="address"
                       required
                       class="form-control"
                       :class="{ 'is-invalid': errors.has('address') }"
                       :title="$t('address')">
                <has-error :form="value" field="address"></has-error>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('phone') }}</label>
            <div class="col-md-7">
                <masked-input v-model="value.phone"
                              mask="\+\38 (011) 111-11-11"
                              name="phone"
                              :required="true"
                              class="form-control"
                              :class="{ 'is-invalid': errors.has('phone') }"
                              :title="$t('phone')"></masked-input>
                <has-error :form="value" field="phone"></has-error>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('email') }}</label>
            <div class="col-md-7">
                <input v-model="value.email"
                       type="email"
                       name="email"
                       required
                       class="form-control"
                       :class="{ 'is-invalid': errors.has('email') }"
                       :title="$t('email')">
                <has-error :form="value" field="email"></has-error>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('work_hours') }}</label>
            <div class="col-md-7">
                <input v-model="value.work_hours"
                       type="text"
                       name="work_hours"
                       class="form-control"
                       :class="{ 'is-invalid': errors.has('work_hours') }"
                       :title="$t('work_hours')">
                <has-error :form="value" field="work_hours"></has-error>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('description') }}</label>
            <div class="col-md-7">
                    <textarea v-model="value.description"
                              name="description"
                              class="form-control"
                              :class="{ 'is-invalid': errors.has('description') }"
                              cols="30"
                              rows="5"
                              :title="$t('description')"></textarea>
                <has-error :form="value" field="description"></has-error>
            </div>
        </div>

        <div class="form-group row">
            <label class="col-md-3 col-form-label text-md-right">{{ $t('published') }}</label>
            <div class="col-md-7">
                <toggle-button :value="value.is_published"
                               :color="colorToggle"
                               :sync="true"
                               :labels="labelToggle"
                               :width="50"
                               @change="changePublished"/>
                <has-error :form="value" field="is_published"></has-error>
            </div>
        </div>

        <!-- Submit Button -->
        <div class="form-group row">
            <div class="col-md-9 ml-md-auto">
                <v-button :loading="value.busy">{{ submitTitle }}</v-button>
            </div>
        </div>
    </form>

</template>

<script>
    import ssLocation from '../../../../components/common/ss_locations.vue';
    import ssHostname from '../../../../components/common/ss_hostname.vue';
    import MaskedInput from 'vue-masked-input';

    export default {
        props: {
            value: {
                type: Object,
                default: () => {
                    return {
                        location: {},
                        title: '',
                        email: '',
                        phone: '',
                        web_hostname: {
                            name: '',
                            type: true
                        },
                        url_type: '',
                        address: '',
                        work_hours: '',
                        description: '',
                        is_published: true
                    }
                }
            },

            errors: {
                type: Object,
                default: () => {
                    return {

                        location: {
                            country: null,
                            region: null,
                            city: null
                        }
                    }
                }
            },

            formTitle: {
                type: String,
                default: () => {
                    return 'Create gym | Update gym';
                }
            },

            submitTitle: {
                type: String,
                default: () => {
                    return 'Submit';
                }
            }
        },

        data: () => {
            return {
                labelToggle: {
                    checked: 'Так',
                    unchecked: 'Ні'
                },
                colorToggle: {
                    checked: '#007bff',
                    unchecked: '#007bff'
                }
            }
        },

        components: {
            ssLocation,
            ssHostname,
            MaskedInput
        },

        computed: {
            //
        },

        methods: {
            changePublished (data) {
                this.$emit('published', data);
            },

            changeTypeUrl (data) {
                this.$emit('typeUrl', data);
            },

            submit () {
                this.$emit('submit');
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/catalog/gym/form/form.vue